export default __webpack_public_path__ + "static/media/Styleguide2.f0dc6f65.png";